document.addEventListener('alpine:init', function () {
  Alpine.data('ctrAutoDiscount', function (code) {
    return {
      code: code || '',
      storageKey: 'ctr-auto-discount',

      init: function () {
        if (!this.code) return;
        this.applyDiscount();
      },

      applyDiscount: function () {
        var code = String(this.code).trim();
        if (!code) return;

        try {
          if (sessionStorage.getItem(this.storageKey) === code) return;
        } catch (e) {}

        var self = this;
        fetch('/discount/' + encodeURIComponent(code), {
          method: 'GET',
          credentials: 'same-origin',
          redirect: 'manual',
        })
          .then(function () {
            try {
              sessionStorage.setItem(self.storageKey, code);
            } catch (e) {}
          })
          .catch(function () {});
      },
    };
  });
});
